"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BookingState = /** @class */ (function () {
    function BookingState() {
        this.loading = false;
        this.number = null;
        this.error = null;
        this.confirmation = null;
    }
    return BookingState;
}());
exports.BookingState = BookingState;
var CruiseState = /** @class */ (function () {
    function CruiseState() {
        this.amenityPrice = 0;
        this.departure = null;
        this.priceModel = null;
    }
    return CruiseState;
}());
exports.CruiseState = CruiseState;
var SexeState = /** @class */ (function () {
    function SexeState() {
    }
    return SexeState;
}());
exports.SexeState = SexeState;
var FormValidationsState = /** @class */ (function () {
    function FormValidationsState() {
    }
    return FormValidationsState;
}());
exports.FormValidationsState = FormValidationsState;
var CountriesState = /** @class */ (function () {
    function CountriesState() {
    }
    return CountriesState;
}());
exports.CountriesState = CountriesState;
var State = /** @class */ (function () {
    function State() {
        // Initialize, would get undefineds otherwise...
        this.booking = new BookingState();
        this.cruise = new CruiseState();
        this.countries = new CountriesState();
        this.paymentCountries = [];
        this.validations = new FormValidationsState();
        this.sexes = new SexeState();
        this.ships = [];
    }
    return State;
}());
exports.State = State;
//# sourceMappingURL=state.js.map